import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import {setAddMealDialog, setAddSpecMealDialog} from '../../../actions/dineIn';
import Typography from '@material-ui/core/Typography';
import lng from '../../../misc/lng';
import envConst from '../../../misc/envConst';
import { useFontSize } from '../../../contexts/FontSizeContext';

const { chiLng } = lng;

const useStyles = makeStyles((theme) => ({
        wrapper: {
        },
        card: {
            width: '90%',
            margin: '20px auto',
            display: 'flex'
        },
        inCardWrapper: {
            padding: '15px',
            display: 'flex',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        details: {
            flex: '2',
            height: '80px',
            display: 'flex',
            flexDirection: 'column',
        },
        inCardDetails: {
            flex: '2',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        img: {
            width: 110,
            height: 80,
            objectFit: 'cover'
        },
        inCardImg: {
            width: 80,
            height: 60,
            objectFit: 'cover',
            borderRadius: '8px',
            marginRight: '15px',
        },
        title: {
            marginTop: '5px',
            marginLeft: '10px',
            // fontSize will be set dynamically
        },
        inCardTitle: {
            fontWeight: '500',
            marginBottom: '4px',
            // fontSize will be set dynamically
        },
        price: {
            marginTop: '5px',
            marginLeft: '10px',
            color: '#d2691e',
            fontWeight: '600',
            // fontSize will be set dynamically
        },
        inCardPrice: {
            color: '#d2691e',
            fontWeight: '600',
            // fontSize will be set dynamically
        },
        outOfStock: {
            opacity: 0.5,
        },
    }
));

// Provide layout for 1st and 2nd menu
const MealBox = (props) => {
    const classes = useStyles(props);
    const dispatch = useDispatch();
    const { getFontSize, updateKey } = useFontSize();
    const {meal, disabled, inCard = false} = props;
    const [img, setImg] = useState(envConst.DEFAULT_IMG_PATH);

    // Dynamic font sizes
    const titleFontSize = getFontSize('mealTitle');
    const priceFontSize = getFontSize('priceMain');


    
    useEffect(() => {
        if (meal && meal.img) {
            setImg(`${envConst.IMAGE_PATH}${meal.img}`);
        } else {
            setImg(envConst.DEFAULT_IMG_PATH);
        }
    }, []);
    
    const handleAddMeal = () => {
        if (meal.hasMenuSpec === 'true') {
            dispatch(setAddSpecMealDialog(true, meal))
        } else {
            dispatch(setAddMealDialog(true, meal))
        }
    }

    const handleImgError = () => {
        setImg(envConst.DEFAULT_IMG_PATH);
    };

    if (inCard) {
        // Render for inside card layout (no individual card wrapper)
        return (
            <div
                key={updateKey}
                className={`${classes.inCardWrapper} ${props.disabled ? classes.outOfStock : ''}`}
                onClick={() => {
                    if (props.disabled) return;
                    handleAddMeal();
                }}
            >
                <CardMedia
                    component="img"
                    alt={meal.name}
                    src={img}
                    className={classes.inCardImg}
                    onError={handleImgError}
                />
                <div className={classes.inCardDetails}>
                    <Typography
                        align='left'
                        className={classes.inCardTitle}
                        style={{ fontSize: titleFontSize }}
                    >
                        {`${meal.name}${props.disabled ? chiLng.outOfStock : ''}`}
                    </Typography>
                    <Typography
                        align='left'
                        className={classes.inCardPrice}
                        style={{ fontSize: priceFontSize }}
                    >
                        {`$${meal.price}`}
                    </Typography>
                </div>
            </div>
        );
    }

    // Original layout for backward compatibility
    return (
        <div
            key={updateKey}
            className={classes.wrapper}
            onClick={() => {
                if (props.disabled) return;
                handleAddMeal();
            }}
        >
            <Card className={`${classes.card} ${props.disabled ? classes.outOfStock : ''}`}>
                <CardMedia
                    component="img"
                    alt={meal.name}
                    src={img}
                    className={classes.img}
                    onError={handleImgError}
                />
                <div className={classes.details}>
                    <Typography
                        align='left'
                        className={classes.title}
                        style={{ fontSize: titleFontSize }}
                    >
                        {`${meal.name}${props.disabled ? chiLng.outOfStock : ''}`}
                    </Typography>
                    <Typography
                        align='left'
                        className={classes.price}
                        style={{ fontSize: priceFontSize }}
                    >
                        {`$${meal.price}`}
                    </Typography>
                </div>
            </Card>
        </div>
    );
};

export default MealBox;